module.exports = __webpack_public_path__ + "static/media/main.d20f6663.png";